"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WechatAppletsLoginOut = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var WechatAppletsLoginOut = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WechatAppletsLoginOut, _super);
    function WechatAppletsLoginOut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '微信小程序退出登录';
        _this.code = '201145';
        _this.desc = '微信小程序退出登录';
        _this.requestParams = new login_1.WechatAppletsLoginOutRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WechatAppletsLoginOut;
}(service_1.BaseService));
exports.WechatAppletsLoginOut = WechatAppletsLoginOut;
//# sourceMappingURL=wechatAppletsLoginOut.js.map